export enum LinkMenuId {
  LineStyle = 'LineStyle',
  MarkStyle = 'MarkStyle',
  Multiplicity = 'Multiplicity',
  ReverseLink = 'ReverseLink',
  Color = 'Color',
  DeleteLink = 'DeleteLink',
}
